const AirPollutionCo2 = ({ size = 45, color = "#fff", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      d="M45 15.133A7.857 7.857 0 0 0 37.5 7.5 10.857 10.857 0 0 0 19.574 6.49a13.669 13.669 0 0 1 8.23 5.156 10.668 10.668 0 0 1 8.663 10.856h1.538a6.357 6.357 0 0 0 5.625-3.169 9.17 9.17 0 0 0 1.368-4.2Z"
    />
    <path
      fill={color}
      d="M4.818 29.175a9.375 9.375 0 0 1 9.225-7.781h8.456a5.625 5.625 0 0 1 5.625 5.625v2.137a6.937 6.937 0 0 0 5.288-5.494c.132-.381.245-.77.337-1.162a7.857 7.857 0 0 0-7.5-8.306 10.82 10.82 0 0 0-18.75.468 10.389 10.389 0 0 0-.975 2.813 6.282 6.282 0 0 0-6.3 5.625 5.194 5.194 0 0 0 4.594 6.075Z"
    />
    <path
      fill={color}
      d="M13.237 35.628a3.357 3.357 0 0 1-3.356-3.337v-2.475a3.357 3.357 0 0 1 3.356-3.357 1.406 1.406 0 1 0 0-2.812 6.188 6.188 0 0 0-6.169 6.169v2.38a6.169 6.169 0 0 0 6.17 6.15 1.406 1.406 0 1 0 0-2.812v.094ZM25.744 28.125a4.434 4.434 0 0 0-8.87 0v5.813a4.425 4.425 0 0 0 8.832 0l.038-5.813Zm-4.407 7.5a1.593 1.593 0 0 1-1.612-1.594v-5.906a1.612 1.612 0 1 1 3.206 0v5.813a1.595 1.595 0 0 1-1.594 1.687ZM33.318 33.022c-3.581 0-4.687 4.93-2.119 4.93a1.425 1.425 0 0 0 1.406-1.405.71.71 0 0 1 .704-.828.713.713 0 0 1 .703.828c.015.338-.077.673-.263.956l-3.562 4.444a1.406 1.406 0 0 0 1.106 2.287h4.219a1.406 1.406 0 0 0 0-2.812h-1.388l1.725-2.044a3.75 3.75 0 0 0-2.531-6.356Z"
    />
  </svg>
);
export default AirPollutionCo2;
